// extracted by mini-css-extract-plugin
export default {"productDescription":"F--z","featuredDescription":"G--z","description":"H--z","more":"I--z","descriptionSku":"J--z"};